import React from "react";
import { useTranslation } from "react-i18next";

// common
import Modal, { ModalText, ModalLayout, MoreModalButtons } from "common/modal";

const { ConfirmationText } = ModalText;
const { ModalRow } = ModalLayout;
const { ButtonContainer, ModalButtonYellow } = MoreModalButtons;

type BookedClassModalProps = {
  visible: boolean;
  onCloseModal: () => void;
  classType: string;
};

const BookedClassModal = ({
  visible,
  onCloseModal,
  classType,
}: BookedClassModalProps) => {
  const { t } = useTranslation("book_a_class");

  const renderModalTitle = () => {
    if (classType.toLowerCase() === "small group") return t("MY GROUP CLASS");
    if (classType.toLowerCase() === "1 on 1") return t("MY 1-ON-1 CLASS");
    return "";
  };

  return (
    <Modal
      title={renderModalTitle()}
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
    >
      <ConfirmationText>
        {t("You have already booked this class.")}
      </ConfirmationText>
      <ModalRow>
        <ButtonContainer xs={18}>
          <ModalButtonYellow
            type="primary"
            onClick={() => {
              onCloseModal();
            }}
          >
            {t("OK")}
          </ModalButtonYellow>
        </ButtonContainer>
      </ModalRow>
    </Modal>
  );
};

export default BookedClassModal;
